(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-product"] && !Shopify.designMode) return;
  try {
    
  class EsGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-es-main]');
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-es-thumb]'));
      this.count = this.querySelector('[data-es-count]');
      this.stage = this.querySelector('.es-pdp__stage');
      this.index = 0;
      this.ready = new Map();
      if (!this.main || this.thumbs.length < 2) return;
      this.ready.set(0, Promise.resolve());
      this.addEventListener('click', (e) => {
        const t = e.target.closest('[data-es-thumb]');
        if (t) { this.show(this.thumbs.indexOf(t)); return; }
        if (e.target.closest('[data-es-prev]')) this.show(this.index - 1);
        else if (e.target.closest('[data-es-next]')) this.show(this.index + 1);
      });
      // Start fetching a photo the moment its thumbnail is pointed at or touched.
      const warmFrom = (e) => {
        const t = e.target && e.target.closest ? e.target.closest('[data-es-thumb]') : null;
        if (t) this.warm(this.thumbs.indexOf(t));
      };
      this.addEventListener('pointerover', warmFrom);
      this.addEventListener('touchstart', warmFrom, { passive: true });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.show(this.index - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.show(this.index + 1); }
      });
      if (this.stage) {
        let x0 = null; let y0 = null;
        this.stage.addEventListener('touchstart', (e) => {
          const p = e.touches[0]; x0 = p.clientX; y0 = p.clientY;
        }, { passive: true });
        this.stage.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const p = e.changedTouches[0]; const dx = p.clientX - x0; const dy = p.clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
      // The first photo is already showing; fetch the second once the page is idle.
      const idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
      const prime = () => idle(() => this.warm(1));
      if (this.main.complete) prime(); else this.main.addEventListener('load', prime, { once: true });
    }
    wrap(i) { const n = this.thumbs.length; return ((i % n) + n) % n; }
    warm(i) {
      i = this.wrap(i);
      if (this.ready.has(i)) return this.ready.get(i);
      const t = this.thumbs[i];
      const img = new Image();
      img.decoding = 'async';
      img.sizes = this.main.getAttribute('sizes') || '100vw';
      if (t.dataset.srcset) img.srcset = t.dataset.srcset;
      img.src = t.dataset.full;
      const p = (img.decode ? img.decode() : new Promise((r) => { img.onload = r; img.onerror = r; })).catch(() => {});
      this.ready.set(i, p);
      return p;
    }
    show(i) {
      i = this.wrap(i);
      if (i === this.index) return;
      this.index = i;
      const t = this.thumbs[i];
      this.thumbs.forEach((b, k) => {
        b.classList.toggle('is-active', k === i);
        if (k === i) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
      });
      if (this.count) this.count.textContent = (i + 1) + ' / ' + this.thumbs.length;
      const slow = setTimeout(() => { if (this.stage) this.stage.classList.add('is-loading'); }, 150);
      this.warm(i).then(() => {
        clearTimeout(slow);
        if (this.stage) this.stage.classList.remove('is-loading');
        if (this.index !== i) return;
        // srcset BEFORE src, with the same candidates the photo was warmed with: one cached fetch.
        this.main.srcset = t.dataset.srcset || '';
        this.main.src = t.dataset.full;
        this.main.alt = t.dataset.alt || '';
      });
      this.warm(i + 1);
      this.warm(i - 1);
    }
  }
  if (!customElements.get('es-gallery')) customElements.define('es-gallery', EsGallery);

  class EsFitment extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('[data-es-fitfind]');
      const none = this.querySelector('[data-es-fitnone]');
      const rows = Array.prototype.slice.call(this.querySelectorAll('tbody tr'));
      // When every row is the same make, say it once above the table and hide the column.
      const makes = rows.map((r) => { const c = r.querySelector('td'); return c ? c.textContent.trim() : ''; });
      const table = this.querySelector('.es-pdp__fittable');
      if (rows.length > 1 && makes[0] && makes.every((m) => m === makes[0]) && table) {
        const cap = document.createElement('p');
        cap.className = 'es-pdp__fitmake';
        cap.innerHTML = 'Make: <strong></strong>';
        cap.querySelector('strong').textContent = makes[0];
        table.parentNode.insertBefore(cap, table);
        this.classList.add('is-one-make');
      }
      if (!input || !rows.length) return;
      const data = rows.map((r) => {
        const cells = r.querySelectorAll('td');
        const yearsCell = cells.length ? cells[cells.length - 1].textContent : '';
        const ys = (yearsCell.match(/\d{4}/g) || []).map(Number);
        let lo = null; let hi = null;
        if (ys.length) {
          lo = Math.min.apply(null, ys); hi = Math.max.apply(null, ys);
          if (ys.length === 1 && /[+]|-\s*$/.test(yearsCell)) hi = 9999;
        }
        // EXACT pass compares with spaces, dashes and punctuation squeezed out, so "KAF 620M" finds
        // "KAF620M" and "zx 6r" finds "ZX-6R".
        const low = r.textContent.toLowerCase();
        return { text: low.replace(/[^a-z0-9]+/g, ''), tokens: low.split(/[^a-z0-9]+/).filter(Boolean), lo: lo, hi: hi };
      });
      const close = this.querySelector('[data-es-fitclose]');
      // Typo distance (optimal string alignment: a swapped pair of letters counts as one edit).
      const osa = (a, b) => {
        if (Math.abs(a.length - b.length) > 2) return 99;
        const d = [];
        for (let i = 0; i <= a.length; i++) d[i] = [i];
        for (let j = 1; j <= b.length; j++) d[0][j] = j;
        for (let i = 1; i <= a.length; i++) {
          for (let j = 1; j <= b.length; j++) {
            d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
            if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
          }
        }
        return d[a.length][b.length];
      };
      const isYear = (w) => /^(19|20)\d\d$/.test(w);
      const yearOk = (w, d) => (d.lo !== null ? Number(w) >= d.lo && Number(w) <= d.hi : d.text.indexOf(w) !== -1);
      // How far a typed word is from the row: 0 = exact, n = n typos, null = no match.
      // NUMBERS MUST MATCH EXACTLY: they are what tell models apart (CRF250 vs CRF450, Mule 4010
      // vs 4012), so only the LETTERS of a word may be forgiven, and only in words of 4+ letters.
      const dist = (w, d) => {
        if (isYear(w)) return yearOk(w, d) ? 0 : null;
        if (d.text.indexOf(w) !== -1) return 0;
        const tol = w.length >= 7 ? 2 : (w.length >= 4 ? 1 : 0);
        if (!tol) return null;
        const wd = w.replace(/\D+/g, '');
        let best = null;
        d.tokens.forEach((t) => {
          if (wd && t.replace(/\D+/g, '').indexOf(wd) === -1) return;
          const e = Math.min(osa(w, t), t.length > w.length ? osa(w, t.slice(0, w.length)) : 99);
          if (e <= tol && (best === null || e < best)) best = e;
        });
        return best;
      };
      // show EVERY qualifying row (each typed word within tolerance, numbers exact), closest first:
      // a cap of 5 hid 8 of 13 equally-close "Mule" rows from someone who typed "mlue"
      const MAX_CLOSE = 20;
      input.addEventListener('input', () => {
        const words = input.value.toLowerCase().trim().split(/\s+/)
          .map((w) => w.replace(/[^a-z0-9]+/g, '')).filter(Boolean);
        rows.forEach((r) => r.classList.remove('is-close'));
        // 1. exact pass
        let shown = 0;
        rows.forEach((r, k) => {
          const hit = words.every((w) => dist(w, data[k]) === 0);
          r.hidden = !hit;
          if (hit) shown += 1;
        });
        // 2. nothing exact: offer the closest rows, LABELLED as "did you mean", never as a fit
        let closeShown = 0;
        if (!shown && words.length) {
          const scored = [];
          data.forEach((d, k) => {
            let total = 0;
            const all = words.every((w) => { const e = dist(w, d); if (e === null) return false; total += e; return true; });
            if (all) scored.push([total, k]);
          });
          scored.sort((x, y) => x[0] - y[0]).slice(0, MAX_CLOSE).forEach(([, k]) => {
            rows[k].hidden = false;
            rows[k].classList.add('is-close');
            closeShown += 1;
          });
        }
        if (close) close.hidden = closeShown === 0;
        if (none) none.hidden = shown !== 0 || closeShown !== 0;
      });
    }
  }
  if (!customElements.get('es-fitment')) customElements.define('es-fitment', EsFitment);

  class EsTierCards extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.idInput = this.form && this.form.querySelector('[data-es-variant-id]');
      this.qtyInput = this.form && this.form.querySelector('[data-es-qty-input]');
      this.priceEl = document.querySelector('[data-es-price]');
      this.stickyPriceEl = document.querySelector('[data-es-sticky-price]');
      this.addEventListener('change', (e) => {
        const radio = e.target.closest('input[type="radio"]');
        if (!radio) return;
        if (this.idInput) this.idInput.value = radio.value;
        if (this.qtyInput && radio.dataset.qty) this.qtyInput.value = radio.dataset.qty;
        this.querySelectorAll('.es-pdp__card').forEach((c) => c.classList.toggle('is-selected', c.contains(radio)));
        const now = '<span class="es-pdp__price-now">' + radio.dataset.now + '</span>';
        const was = radio.dataset.was ? '<s class="es-pdp__price-was">' + radio.dataset.was + '</s>' : '';
        if (this.priceEl) this.priceEl.innerHTML = now + was;
        if (this.stickyPriceEl) this.stickyPriceEl.innerHTML = now + was;
      });
    }
  }
  if (!customElements.get('es-tier-cards')) customElements.define('es-tier-cards', EsTierCards);

  (function () {
    const bar = document.querySelector('[data-es-stickybar]');
    const trigger = document.querySelector('.es-pdp__cards') || document.querySelector('.es-pdp__actions');
    if (bar && trigger && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
          bar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, { threshold: 0 });
      io.observe(trigger);
    }

    const buyBtn = bar && bar.querySelector('[data-es-sticky-buy]');
    if (buyBtn) {
      buyBtn.addEventListener('click', async () => {
        const form = document.getElementById('es-product-form');
        if (!form) return;
        const idEl = form.querySelector('[data-es-variant-id]');
        const qtyEl = form.querySelector('[name="quantity"]');
        const id = idEl && idEl.value;
        if (!id) return;
        const quantity = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
        buyBtn.disabled = true;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: quantity })
          });
          if (!res.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        } catch (e) {
          buyBtn.disabled = false;
        }
      });
    }
  })();

  // Quantity stepper next to Add to cart. On single-variant products the displayed price
  // is the order total (unit × qty) so the shipping line under it stays true; at qty 1 the
  // server-rendered price (incl. any compare-at strike) is restored. Multi-variant products
  // show the selected variant's price and the stepper only sets the quantity.
  (function () {
    const form = document.getElementById('es-product-form');
    if (!form) return;
    const qtyInput = form.querySelector('[data-es-qty-input]');
    const stepper = form.querySelector('[data-es-qty-stepper]');
    if (!qtyInput || !stepper) return;
    const unitCents = parseInt(stepper.dataset.esUnitPrice, 10) || 0;
    const priceEl = document.querySelector('[data-es-price]');
    const stickyPriceEl = document.querySelector('[data-es-sticky-price]');
    const initialPrice = priceEl ? priceEl.innerHTML : '';
    const initialSticky = stickyPriceEl ? stickyPriceEl.innerHTML : '';
    const nowEl = priceEl && priceEl.querySelector('.es-pdp__price-now');
    const prefixMatch = nowEl && (nowEl.textContent || '').match(/^[^0-9]*/);
    const prefix = prefixMatch ? prefixMatch[0] : '$';
    function money(cents) { return prefix + (cents / 100).toFixed(2); }
    function renderPrice(q) {
      if (!unitCents) return;
      if (q === 1) {
        if (priceEl) priceEl.innerHTML = initialPrice;
        if (stickyPriceEl) stickyPriceEl.innerHTML = initialSticky;
        return;
      }
      const html = '<span class="es-pdp__price-now">' + money(unitCents * q) + '</span>';
      if (priceEl) priceEl.innerHTML = html;
      if (stickyPriceEl) stickyPriceEl.innerHTML = html;
    }
    function readQty() { let v = parseInt(qtyInput.value, 10); if (isNaN(v) || v < 1) v = 1; return v; }
    function applyQty(q) { qtyInput.value = q; renderPrice(q); }

    stepper.querySelector('[data-es-qty-down]').addEventListener('click', function () { applyQty(Math.max(1, readQty() - 1)); });
    stepper.querySelector('[data-es-qty-up]').addEventListener('click', function () { applyQty(readQty() + 1); });
    qtyInput.addEventListener('change', function () { applyQty(readQty()); });
  })();

  // Buy now: add the chosen variant + quantity, then straight to checkout.
  (function () {
    const btn = document.querySelector('[data-es-buynow]');
    if (!btn) return;
    // Back from checkout restores this page from the browser cache with the button still 'loading': reset it.
    window.addEventListener('pageshow', function () { btn.classList.remove('is-loading'); });
    btn.addEventListener('click', function () {
      const idEl = document.querySelector('[data-es-variant-id]');
      const qtyEl = document.querySelector('[data-es-qty-input]');
      const id = idEl && Number(idEl.value);
      const qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
      if (!id) return;
      btn.classList.add('is-loading');

      // Preferred route: a Storefront API cart holding only this line, checked out on its own,
      // so whatever is in the shopper's cart is left exactly as it was. See snippets/es-buy-now.
      // It resolves to null (never rejects) whenever that route is unavailable, and then the
      // pre-2026-10-16 fallback below runs instead.
      (window.esBuyNow ? window.esBuyNow(id, qty) : Promise.resolve(null))
        .then(function (checkoutUrl) {
          if (checkoutUrl) { window.location.href = checkoutUrl; return; }
          // FALLBACK. Empty cart: the cart permalink goes straight to checkout with just this item (one request).
          // Cart already holds other parts: a permalink would WIPE them, so add this one and open the cart drawer instead.
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var others = (cart.items || []).filter(function (i) { return i.variant_id !== id; });
              if (!others.length) { window.location.href = '/cart/' + id + ':' + qty; return; }
              return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) })
                .then(function () {
                  btn.classList.remove('is-loading');
                  var open = document.querySelector('[data-em-cart-open]');
                  if (open) { open.click(); } else { window.location.href = '/cart'; }
                });
            })
            .catch(function () { window.location.href = '/cart/' + id + ':' + qty; });
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-related-products"] && !Shopify.designMode) return;
  try {
    
  class EsRelatedProducts extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url || this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      fetch(url)
        .then((r) => {
          if (!r.ok) throw new Error('recommendations failed');
          return r.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const fresh = doc.querySelector('es-related-products');
          if (fresh && fresh.querySelector('.es-related__grid')) {
            this.innerHTML = fresh.innerHTML;
            const sec = this.closest('.es-related');
            if (sec) sec.removeAttribute('hidden');
          }
        })
        .catch(() => {});
    }
  }
  if (!customElements.get('es-related-products')) customElements.define('es-related-products', EsRelatedProducts);

  } catch(e) { console.error(e); }
})();
})();
